import { IVocTreeEdit } from 'models/VocabularyModel';
import React from 'react';
import { TreeNode } from 'react-organizational-chart';
import VocTreeNodeItem from './VocTreeNodeItem';

export type IProps = {
  item: IVocTreeEdit;
  onUnlinkChild?: (childId: number) => void;
  onUnlinkSynonym?: (synonymId: number) => void;
  onUnlinkSelf?: () => void;
  isRoot?: boolean;
};

const VocTreeNode: React.FC<IProps> = (props) => {
  return (
    <TreeNode
      label={
        <VocTreeNodeItem
          item={props.item}
          onUnlinkChild={props.onUnlinkChild}
          onUnlinkSynonym={props.onUnlinkSynonym}
          onUnlinkSelf={props.onUnlinkSelf}
          isRoot={props.isRoot}
        />
      }
    >
      {props.item.children.map((child) => (
        <VocTreeNode
          item={child}
          key={child.id}
          onUnlinkChild={props.onUnlinkChild}
          onUnlinkSynonym={props.onUnlinkSynonym}
          onUnlinkSelf={props.onUnlinkSelf}
          isRoot={false}
        />
      ))}
    </TreeNode>
  );
};

export default VocTreeNode;
